import Vue from 'vue'
import App from './App.vue'
import router from './router' // 导入路由实例

// 引入全局 CSS 文件（注意路径要正确）
import './styles/global.css'  // 引入全局样式
import './styles/iconfont.css'  // 引入ICON图标库
import 'animate.css'

// 引入 Element UI
import ElementUI from 'element-ui'
// 引入 Element UI 样式
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'Vmw07JR4JH29jtH5aZjPLjtVsZdRC2vG'
})

// 引入全局组件注册函数
import { registerGlobalComponents } from './components/global'
// const app = createApp(App)

// 注册全局组件
// registerGlobalComponents(app)
registerGlobalComponents(Vue)

// 引入 wowjs
import { WOW } from 'wowjs'
// 全局实例化 WOW
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 触发动画的元素类名（默认即可）
  animateClass: 'animated', // 动画类名前缀（对应 animate.css 的类）
  offset: 0, // 元素距离视口多少像素时触发动画
  mobile: true, // 是否在移动端触发动画（移动端建议开启）
  live: true // 是否监听动态添加的元素
})
// 检测设备类型并跳转
function checkDeviceAndRedirect() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    
    if (!isMobile && window.location.hostname !== 'www.3pg.cn') {
        window.location.href = 'https://www.3pg.cn'
    }
}

// 执行检测
checkDeviceAndRedirect()
import AV from 'leancloud-storage'
// const AV = require("leancloud-storage");
// const { Query, User } = AV;

AV.init({
  appId: '9rXqIZHsGPUfozzLKmCRzDaU-gzGzoHsz',
  appKey: 'W4rV92VWVQq2GRbXEjf93tSb',
  serverURL: 'https://9rxqizhs.lc-cn-n1-shared.com'
})
Vue.prototype.$AV = AV

// 创建Vue实例
new Vue({
    el: '#app',
    router, // 使用路由
    render: h => h(App)
})
